<template>
  <div
    class="number-line-section tw-flex tw-items-center tw-justify-center tw-px-1 tw-text-center"
    :style="{
      backgroundColor: backgroundImage ? null : color,
      flexBasis: displayWidth || 0,
      flexGrow: displayWidth ? null : 1,
      borderRight: isLast ? null : '1px solid rgba(0,0,0,0.3)',
    }"
  >
    <div class="">
      {{ label }}
    </div>
  </div>
</template>


<script>
export default {
  name: 'NumberLineSection',
  components: {
    // No subcomponents for now
  },
  props: [
    'isLast',
    'label',
    'color',
    'backgroundImage',
    'width',
    'min',
    'max',
  ],
  data() {
    return {
      // Local variables can be defined here if needed
    };
  },
  computed: {
    // Creates a new property
    // Updates when any dependent property changes
    // width = displayWidth / range
    displayWidth() {
      if (!this.width) return null;
      const range = this.max - this.min;
      return `${(this.width / range) * 100}%`;
    },
  },
  watch: {
    // Watches an existing property
    // Only runs when the watched property changes
  },
  created() {},
  mounted() {},
  updated() {},
  methods: {
    // Add your methods here
  },
};
</script>


<style scoped>

</style>
